import * as dataUtils from '../../utils/dataUtils';

import StorageItem from './StorageItem';


const STORAGE_PREFIX = 'jnex.';


class DataStorageService {

    /**
     * @type {Storage}
     * @private
     */
    storage;


    /**
     * @type {{}}
     * @private
     */
    listeners = {};


    /**
     * @param storage {Storage} Storage API to use
     */
    constructor(storage) {

        this.storage = storage;
    }


    set(name, value, notify = true) {

        const storageItem = new StorageItem(name, JSON.stringify(value));

        this.storage.setItem(STORAGE_PREFIX + name, JSON.stringify(storageItem));

        if (notify) {
            this.notify(name, storageItem);
        }
    }


    get(name, defaultValue = null) {

        let storedItem = this.storage.getItem(STORAGE_PREFIX + name);

        if (!storedItem) {

            return defaultValue;
        }

        const storageItem = this.deserializeStorageItem(storedItem);

        return storageItem.getValue();
    }


    delete(name) {

        this.storage.removeItem(STORAGE_PREFIX + name);
    }


    addListener(name, listener) {

        if (this.listeners[name] === undefined) {
            this.listeners[name] = [];
        }

        this.listeners[name].push(listener);
    }


    clear() {

        dataUtils.each(this.storage, key => {

            if (key.indexOf(STORAGE_PREFIX) === 0) {

                this.delete(key.replace(STORAGE_PREFIX, ''));
            }
        });
    }


    deserializeStorageItem = storedItem => {

        const storageItem = new StorageItem();

        JSON.parse(storedItem, (key, value) => {

            if (storageItem.hasOwnProperty(key)) {
                storageItem[key] = value;
            }
        });

        return storageItem;
    };


    notify = (name, storageItem) => {

        let listeners = this.listeners[name];

        // no listeners or all removed - nothing to do
        if (!listeners || listeners.length < 1) {

            return;
        }

        // call each listeners
        listeners.forEach(listener => listener(storageItem));
    };
}


export default DataStorageService;
